import { isAndroidDevice } from '@/utils/mobile-device';

/**
 * Returns true if the device used is Android
 */
export function height(): number {
  return isAndroidDevice() ? 60 : 76;
}

/**
 * Returns true if the device used is iOS
 */
export function cssHeight(): string {
  return isAndroidDevice() ? '50 px;' : '76 px;';
}
